/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * Describes in what state a `PlagiarismRun` is.
 */
export const PlagiarismState = /* #__PURE__ */ parsers.exactly('starting', 'done', 'crashed', 'started', 'parsing', 'running', 'finalizing', 'comparing');
